import React from 'react';
import { ParallaxProvider, config } from '@adc/parallax-component-library';
const Providers = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(ParallaxProvider, {
    config: config,
    locale: "en-US",
    dir: "ltr",
    isTestEnvironment: true,
    defaultTheme: 'light'
  }, children);
};
export default Providers;